module.exports = __webpack_public_path__ + "img/组 11 拷贝@2x.1a1fadae.png";